import React from 'react';

export default function ReadingArticle({ body, children, ...props }) {
  return (
    <section data-reading-position {...props}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 col-md-10">
            <article className="article lead" dangerouslySetInnerHTML={{ __html: body }} />
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}